import Vue from 'vue';
import VeeValidate from 'vee-validate';

const PhoneNumber = require('awesome-phonenumber');
const CountryCodes = require('country-codes-list');



Vue.use(require('vue-moment'));
Vue.use(VeeValidate);

VeeValidate.Validator.extend('verify-password', {
    getMessage: field => `The ${field} must have a minimum of 6 characters, one uppercase letter, one lowercase letter and one number.`,
    validate: value => {
        const passwordValidator = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}/;
        return passwordValidator.test(value);
    }
});


VeeValidate.Validator.extend('name', {
    getMessage: field => `The ${field} field can only contain letters, numbers, hyphens and spaces`,
    validate: value => {
        const nameValidator = /^[a-zA-Z0-9 -]{1,}$/;
        return nameValidator.test(value);
    }
});

VeeValidate.Validator.extend('two-words', {
    getMessage: field => `The ${field} field must contain one space`,
    validate: value => {
        const nameValidator = /(\w.+\s).+/;
        return nameValidator.test(value);
    }
});

VeeValidate.Validator.extend('full-name', {
    getMessage: () => `Please enter your first and last names`,
    validate: value => {
        const nameValidator = /(\w.+\s).+/;
        return nameValidator.test(value);
    }
});

VeeValidate.Validator.extend('minimum-age', {
    getMessage: field => `Must be at least 18 years old.`,
    validate: value => {
        const userDateOfBirth = Vue.moment(value);
        var workingDate = Vue.moment();
        workingDate.subtract(18, 'years');
        return userDateOfBirth <= workingDate;
    }
});

VeeValidate.Validator.extend('bank-name', {
    getMessage: field => `The ${field} field can only contain letters, numbers, spaces and hyphens`,
    validate: value => {
        const validator = /^[a-zA-Z0-9 -]+$/;
        return validator.test(value);
    }
});

VeeValidate.Validator.extend('international-phone', {
    getMessage: (field) => `Enter phone number starting with country code e.g. +1, +234, +44, etc.`,
    validate: (value) => {
        const validator = /^\+(?:[0-9] ?-?){6,20}[0-9]$/;
        return validator.test(value);
    },
    params: ['posterCountry'],
});

VeeValidate.Validator.extend('phone-plus', {
    getMessage: (field) => `Enter phone number starting with country code e.g. +1, +234, +44, etc.`,
    validate: (value) => {
        const validator = /^\+/;
        return validator.test(value);
    },
});

VeeValidate.Validator.extend('phone-length', {
    getMessage: (field) => 'Minimum of 7 digits',
    validate: (value) => {
        const validator = /(?:[0-9] ?-?){6,20}[0-9]$/;
        return validator.test(value);
    },
});

VeeValidate.Validator.extend('phone', {
    getMessage: field => `The ${field} field must be a valid phone number. Format: 555-555-5555`,
    validate: value => {
        const validator = /^(?:[0-9] ?-?){6,20}[0-9]$/;
        return validator.test(value);
    },
});

VeeValidate.Validator.extend('country-code', {
    getMessage: (field, posterCountry) => {
        const countryCodesList = CountryCodes.customList('countryNameEn', '+{countryCallingCode}');
        const posterCountryCallingCode = _.get(countryCodesList, posterCountry);
        return `The ${field} field must be from ${posterCountry}. Format: ${posterCountryCallingCode}...`
    },
    validate: (value, posterCountry) => {
        const countryCodesList = CountryCodes.customList('countryNameEn', '{countryCode}');
        const phoneNumberCountryCode = new PhoneNumber(value).getRegionCode();
        const posterCountryCode = _.get(countryCodesList, posterCountry);
        const validator = phoneNumberCountryCode === posterCountryCode;
        return validator;
    },
    params: ['posterCountry'],
});

VeeValidate.Validator.extend('between', {
    getMessage: (_, placeholders) => `Oops! Rate must be between ${placeholders[0]} and ${placeholders[1]}.`,
    validate(value, params) {
        const v = parseInt(value, 10);
        const min = parseInt(params[0], 10);
        const max = parseInt(params[1], 10);
        return v >= min && v <= max;
    },
});

VeeValidate.Validator.extend('street-address', {
    getMessage: () => 'Street address must start with a number',
    validate: (value) => !isNaN(value.charAt(0)),
});

export default VeeValidate;
